var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.137,
    height: 18.137,
    viewBox: "0 0 18.137 18.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(-2.93 -2.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_142",
    "data-name": "Vrstva 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_158",
    fill: "#fff",
    d: "M10.88 20.19l9.31-9.31a3 3 0 0 0 0-4.24l-2.83-2.83a3 3 0 0 0-4.24 0l-9.31 9.31a3 3 0 0 0-.88 2.12v5.83h5.83a3 3 0 0 0 2.12-.88zm-6-5a1 1 0 0 1 .29-.7l9.32-9.32a1 1 0 0 1 1.41 0L18.73 8a1 1 0 0 1 0 1.41l-9.27 9.37a1 1 0 0 1-.7.29H4.93z",
    "data-name": "Trazado 158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.a32500186b2b54713dd17697acbbcdb3.svg";
export { ForwardRef as ReactComponent };